export enum OperationsRole {
  sales = 'sales',
  salesManager = 'sales_manager',
  hr = 'hr',
  hrManager = 'hr_manager',
  legal = 'legal',
  compliance = 'compliance',
  operationsAdmin = 'operations_admin',
  executive = 'executive',
  finance = 'finance',
  support = 'support',
}

export interface OperationsUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: OperationsRole | 'operationsAdmin';
  status: 'active' | 'inactive' | 'suspended';
  department?: string;
  phoneNumber?: string;
  createdAt: Date;
  lastLogin?: Date;
  metadata?: Record<string, unknown>;
}

export interface OperationsUserProfile extends OperationsUser {
  fullName: string;
  isActive: boolean;
  canAccessSales: boolean;
  canAccessHR: boolean;
  canAccessLegal: boolean;
  canAccessCompliance: boolean;
}

// User Profile from the main app (members, employers, providers)
export enum UserRole {
  member = 0,
  employerAdmin = 1,
  faircareAdmin = 2,
  reviewer = 3,
  provider = 4,
}

export enum AccountStatus {
  active = 0,
  inactive = 1,
  suspended = 2,
  pendingVerification = 3,
}

export interface UserProfile {
  userId: string;
  email: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  role: UserRole;
  status: AccountStatus;
  profileImageUrl?: string;
  dateOfBirth?: Date;
  gender?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  createdAt: Date;
  lastUpdated: Date;
  metadata?: Record<string, unknown>;
  mustChangePassword: boolean;
}
